module.exports = "div.b {\r\n    text-align: justify; /* For Edge */ /* For Firefox prior 58.0 */\r\n    text-align-last: center;\r\n}\r\n#mydiv {\r\n    top: 50%;\r\n    left: 50%;\r\n    width:30em;\r\n    height:18em;\r\n    margin-top: -9em; /*set to a negative number 1/2 of your height*/\r\n    margin-left: -15em; /*set to a negative number 1/2 of your width*/\r\n    border: 1px solid #ccc;\r\n    background-color: #f3f3f3;\r\n    position:fixed;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/TowLocate/results/results.component.css
// module id = ./src/app/Components/TowLocate/results/results.component.css
// module chunks = main